/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  LinkBusinessRelationshipToProductionSiteMutationRequest,
  LinkBusinessRelationshipToProductionSiteMutationResponse,
} from "../types/LinkBusinessRelationshipToProductionSite.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const linkBusinessRelationshipToProductionSiteMutationKey = () =>
  [
    {
      url: "/v1/production-site/link-business-relationship-to-production-site",
    },
  ] as const

export type LinkBusinessRelationshipToProductionSiteMutationKey = ReturnType<
  typeof linkBusinessRelationshipToProductionSiteMutationKey
>

/**
 * @summary Link existing business relationship to production site
 * {@link /v1/production-site/link-business-relationship-to-production-site}
 */
export async function linkBusinessRelationshipToProductionSite(
  data: LinkBusinessRelationshipToProductionSiteMutationRequest,
  config: Partial<
    RequestConfig<LinkBusinessRelationshipToProductionSiteMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    LinkBusinessRelationshipToProductionSiteMutationResponse,
    ResponseErrorConfig<Error>,
    LinkBusinessRelationshipToProductionSiteMutationRequest
  >({
    method: "POST",
    url: `/v1/production-site/link-business-relationship-to-production-site`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function linkBusinessRelationshipToProductionSiteMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<LinkBusinessRelationshipToProductionSiteMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = linkBusinessRelationshipToProductionSiteMutationKey()
  return mutationOptions<
    ResponseConfig<LinkBusinessRelationshipToProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LinkBusinessRelationshipToProductionSiteMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return linkBusinessRelationshipToProductionSite(data, config)
    },
  })
}

/**
 * @summary Link existing business relationship to production site
 * {@link /v1/production-site/link-business-relationship-to-production-site}
 */
export function useLinkBusinessRelationshipToProductionSite<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<LinkBusinessRelationshipToProductionSiteMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: LinkBusinessRelationshipToProductionSiteMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<LinkBusinessRelationshipToProductionSiteMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ??
    linkBusinessRelationshipToProductionSiteMutationKey()

  const baseOptions = linkBusinessRelationshipToProductionSiteMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<LinkBusinessRelationshipToProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LinkBusinessRelationshipToProductionSiteMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<LinkBusinessRelationshipToProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LinkBusinessRelationshipToProductionSiteMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<LinkBusinessRelationshipToProductionSiteMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: LinkBusinessRelationshipToProductionSiteMutationRequest },
    TContext
  >
}
